import {
  COLLAPSE_MENU, SHOW_SUBMENU, TOGGLE_MENU, CHANGE_TASKS_INFO, CHANGE_INVALID_SESSION,
  COLLAPSE_FILTERS, TOGGLE_FILTERS, SHOW_CONFETTI, HIDE_CONFETTI, SET_STREAMER_TIME_PERIOD
} from "./constants";

const initialState = {
  tasksInfo: {},
  invalidSessionFormat: null,
  sidebar: {
    isCollapsed: false,
    isShowSubmenu: false,
    isShowMenu: false,
  },
  filters: {
    isCollapsed: false,
    isShowMenu: false,
  },
  confetti: false,
  streamerTimePeriod: 'thismonth',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case COLLAPSE_MENU:
      return {...state, sidebar: {...state.sidebar, isCollapsed: !state.sidebar.isCollapsed}};

    case SHOW_SUBMENU:
      return {...state, sidebar: {...state.sidebar, isShowSubmenu: !state.sidebar.isShowSubmenu}};

    case TOGGLE_MENU:
      return {...state, sidebar: {...state.sidebar, isShowMenu: !state.sidebar.isShowMenu}};

    case CHANGE_TASKS_INFO:
      return {...state, tasksInfo: action.payload};

    case CHANGE_INVALID_SESSION:
      return {...state, invalidSessionFormat: action.payload};

    case COLLAPSE_FILTERS:
      return {...state, filters: {...state.filters, isCollapsed: !state.filters.isCollapsed}};

    case TOGGLE_FILTERS:
      return {...state, filters: {...state.filters, isShowMenu: !state.filters.isShowMenu}};

    case SHOW_CONFETTI:
      return {...state, confetti: true};

    case HIDE_CONFETTI:
      return {...state, confetti: false};

    case SET_STREAMER_TIME_PERIOD:
      return {...state, streamerTimePeriod: action.payload};

    default:
      return state;
  }
};
